import {metadaApi} from '@dms/api/base';

import {
  GetAvailableTemplatesRequest,
  GetAvailableTemplatesRequestSchema,
  GetAvailableTemplatesResponse,
  GetAvailableTemplatesResponseSchema,
} from './types';

export const metadaWarehouseAvailableTemplatesApi = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    getAvailableTemplates: build.query<GetAvailableTemplatesResponse, GetAvailableTemplatesRequest>(
      {
        query: (queryArg) => ({
          url: `warehouse/v1/available-templates`,
          method: 'GET',
          params: {
            warehouseId: queryArg.warehouseId,
            directSaleVariantId: queryArg.directSaleVariantId,
            supplierOrderVariantId: queryArg.supplierOrderVariantId,
          },
          queryArg,
        }),
        extraOptions: {
          requestSchema: GetAvailableTemplatesRequestSchema,
          responseSchema: GetAvailableTemplatesResponseSchema,
        },
        transformResponse: (response: GetAvailableTemplatesResponse) =>
          response
            .map((document) => ({
              ...document,
              templates: document.templates.filter((template) => !template.isHidden),
            }))
            .filter((document) => document.templates.length > 0),
      }
    ),
  }),
});

export const {useGetAvailableTemplatesQuery} = metadaWarehouseAvailableTemplatesApi;
